module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Call#1-f32c6ffed0a1910e7c9fce64804d41d8.svg";